import { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import { EditIcon, CloseIcon } from "../kits/Icons";
import OrderOptionCheckList from "./OrderOptionCheckList";
import CustomButton from "../kits/button/CustomButton";
import useAxios from "../../services/useAxios";
import ToastCustomize from "../kits/ToastCustomize";
export default function EditModalOrderOption({
  data,
  priceType,
  orderOptionsApi,
}) {
  const [editModalShow, setEditModalShow] = useState(false);
  const [errorTxt, setErrorTxt] = useState({ perUnit: "" });
  const [editData, setEditData] = useState({ params: [], values: [] });
  const { loading, execute: EditModalData } = useAxios(
    "api/edit_option_order_pservice_link"
  );

  const priceHandler = (index, object) => {
    let temp = [...editData.values];
    temp = temp.map((v) => {
      if (v.index == index) {
        return { ...v, ...object };
      } else return v;
    });
    // temp[index] = { ...temp[index], ...object };
    console.log("test data", temp, index, object);
    setEditData((prev) => {
      return { ...prev, values: temp };
    });
  };
  const optionAnswerHandler = (object) => {
    let selectId = editData?.values?.findIndex((o) => o.name == object.name);
    let test;

    if (selectId == -1) {
      let temp = {
        ...editData,
        values: [
          ...editData.values,
          {
            ...object,
            status: true,
            priceOnOrder: "",
            pricePerUnit: "",
            unit: -1,
          },
        ],
      };

      setEditData(temp);
    } else {
      const temp = editData.values;
      [temp[selectId], ...test] = temp;

      setEditData((prev) => {
        return { ...prev, values: test };
      });
    }
  };
  const editModalData = () => {
    let temp = {
      p_service_id: editData.p_service_id,
      option_order_id: editData.option_order__id,
      value: editData.values
        .filter((v) => v.status == true)
        .map((v) => JSON.stringify(v))
        .join("@@"),
    };
    EditModalData(temp).then((result) => {
      if (result.status == 1) {
        orderOptionsApi();
        setEditModalShow(false);
        ToastCustomize({
          mainText: "ویرایش با موفقیت انجام شد!",
          duration: 2000,
          toastType: "success",
          color: "success",
          position: "top-center",
          hasHeader: false,
        });
      } else {
        ToastCustomize({
          mainText: "متاسفانه مشکلی پیش آمده است، دوباره تلاش کنید.!",
          duration: 2000,
          toastType: "danger",
          color: "danger",
          position: "top-center",
          hasHeader: false,
        });
      }
    });
  };
  useEffect(() => {
    if (editModalShow) setEditData(data);
  }, [editModalShow]);
  console.log("object check list temp edit*** ", editData);
  return (
    <div>
      <div onClick={() => setEditModalShow(true)}>
        {" "}
        <EditIcon
          color="white"
          containerIconClassName="edit-icon mx-2 rounded p-1 cursor-pointer"
        />
      </div>

      <Modal
        show={editModalShow}
        onHide={() => setEditModalShow(false)}
        size="lg"
        fullscreen="lg-down"
      >
        <Modal.Header>
          ویرایش {data.title}
          <div
            onClick={() => {
              setEditModalShow(false);
            }}
          >
            <CloseIcon />
          </div>
        </Modal.Header>
        <Modal.Body>
          <div className="option-list edit-oOption-modal ">
            {" "}
            <OrderOptionCheckList
              data={editData}
              selected={editData?.values}
              optionAnswerHandler={optionAnswerHandler}
              priceType={priceType}
              priceHandler={priceHandler}
            />
          </div>
          <div
            className="d-flex justify-content-end"
            onClick={() => {
              editModalData();
            }}
          >
            <CustomButton color="primary">ویرایش</CustomButton>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}
